/* eslint-disable prettier/prettier */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable import/order */
import { FC } from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Span } from 'libs/common-components/src';
import dayjs from 'dayjs';
import { IDamageData } from '@bvi/api-interfaces/response/manage-base-data';
import { DamageActionMenu } from '@bvi/admin-panel/feature/damages/ui/damage-action-menu';
import { styles } from '@bvi/admin-panel/feature/manage-list/ui/manage-base-table/manage-base-row/styles';

interface IDamageTableRowProperties {
  damage: IDamageData;
}

export const DamageTableRow: FC<IDamageTableRowProperties> = ({
  damage,
  ...properties
}) => {
  const dateFormatted = dayjs(damage.createdAt).format('MM/DD/YYYY');

  return (
    <TableRow {...properties}>
      <TableCell>
        <Span sx={styles.tooltipContent}>{damage.id}</Span>
      </TableCell>
      <TableCell>
        <Span sx={styles.tooltipContent}>{damage.name}</Span>
      </TableCell>
      <TableCell>
        <Span sx={styles.tooltipContent}>{dateFormatted}</Span>
      </TableCell>
      <TableCell>
        <DamageActionMenu
          id={damage.id}
          detail={damage}
        />
      </TableCell>
    </TableRow>
  );
};

